import type { FieldsetHTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export interface FieldsetProps extends FieldsetHTMLAttributes<HTMLFieldSetElement> {
  legend?: ReactNode;
  legendClassName?: string;
  legendIsPageHeading?: boolean;
  legendLang?: string;
  children?: ReactNode;
}

/** govuk/components/fieldset */
export function Fieldset({ legend, legendClassName, legendIsPageHeading, legendLang, className, children, ...rest }: FieldsetProps) {
  return (
    <fieldset className={cx('govuk-fieldset', className)} {...rest}>
      {legend !== undefined && legend !== null && (
        <legend className={cx('govuk-fieldset__legend', legendClassName)} lang={legendLang}>
          {legendIsPageHeading ? (
            <h1 className="govuk-fieldset__heading" tabIndex={-1}>
              {legend}
            </h1>
          ) : (
            legend
          )}
        </legend>
      )}
      {children}
    </fieldset>
  );
}
